/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import FuseAnimate from '@/@fuse/core/FuseAnimate';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import CustomDatePicker from '@shared/customComponents/CustomDatePicker/CustomDatePicker';
import { getCompanySchools, updateSchoolStatus } from '@/app/services/schools/schools';
import * as Actions from '@/app/store/actions';
import { CircularProgress, IconButton, InputAdornment, TextField } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import dayjs from 'dayjs';
import Pusher from 'pusher-js';
import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import './SubAdmins.css';
import { useNavigate } from 'react-router-dom';
import ChangeSchoolManagerModal from '@shared/components/school/ChangeSchoolManagerModal';
import CustomSwitch from '@shared/components/CustomSwitch';
import GradientButton from 'shared/components/GradientButton';
import ConfirmModal from 'shared/components/ConfirmModal/ConfirmModal';

const useStyles = makeStyles({
	container: {
		height: 540,
		position: 'fixed',
		maxWidth: '100%',
		width: '100%',
		paddingLeft: 30,
		paddingRight: 30,
		borderRadius: 14,
		overflowY: 'scroll',
		marginTop: '21px',
	},
	root: {
		color: '#2D65AB',
	},
});

const Schools = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const classes = useStyles();
	const [rows, setRows] = useState([]);
	const [refresh, setRefresh] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [searchQuery, setSearchQuery] = useState('');
	const [fromDate, setFromDate] = useState('');
	const [toDate, setToDate] = useState('');
	const [firstLoad, setFirstLoad] = useState(true);
	const [hasMore, setHasMore] = useState(false);
	const [page, setPage] = useState(1);
	const [fetchingMore, setFetchingMore] = useState(false);
	const [selectedToEdit, setSelectedToEdit] = useState(null);
	const [open, setOpen] = useState(false);
		const [isRequesting, setIsRequesting] = useState(false);
	const user = useSelector(({ auth }) => auth.user);
	let pusher;
	let channel;

	const GetSchoolListing = () => {
		setIsLoading(true);
		setFirstLoad(false);
		getCompanySchools(searchQuery, fromDate, toDate, 1)
			.then((res) => {
				if (res.data.last_page > res.data.current_page) {
					setHasMore(true);
				} else {
					setHasMore(false);
				}
				setPage(res.data.current_page + 1);
				setRows(res.data.data);
				setIsLoading(false);
			})
			.catch(() => {
				setIsLoading(false);
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					})
				);
			});
	};

	useEffect(() => {
		pusher = new Pusher(import.meta.env.VITE_PUSHER_CHANNEL_ID, {
			cluster: import.meta.env.VITE_PUSHER_CLUSTER_ID,
		});
		channel = pusher.subscribe(`company_app_${user.data.school.id}`);
		channel.bind('school_update', () => {
			GetSchoolListing();
		});
		channel.bind('school_disabled', () => {
			GetSchoolListing();
		});
		return () => {
			pusher.disconnect();
		};
	}, []);

	useEffect(() => {
		const id = setTimeout(
			() => {
				GetSchoolListing();
			},
			firstLoad ? 0 : 1000
		);

		return () => {
			clearTimeout(id);
		};
	}, [refresh, fromDate, toDate, searchQuery, dispatch]);

	const goToEdit = (row) => {
		navigate(`/editschool/${row.id}`, {
			state: {
				row,
			},
		});
	};

	const goToAdd = () => {
		navigate('/addschool');
	};

	const handleDisable = (e, row) => {
		e.preventDefault();
		setOpen(true);
		setSelectedToEdit(row);
	};

	const handleSearch = (e) => {
		setSearchQuery(e.target.value);
	};

	const handleLoadMore = () => {
		setFetchingMore(true);
		getCompanySchools(searchQuery, fromDate, toDate, page)
			.then((res) => {
				if (res.data.last_page > res.data.current_page) {
					setHasMore(true);
				} else {
					setHasMore(false);
				}
				setPage(res.data.current_page + 1);
				setRows(rows.concat(res.data.data));
				setFetchingMore(false);
			})
			.catch(() => {
				setFetchingMore(false);
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					})
				);
			});
	};

	const handleFromDate = (date) => {
		if (date) {
			setFromDate(dayjs(date).format('YYYY-MM-DD'));
		} else {
			setFromDate('');
		}
	};

	const handleToDate = (date) => {
		if (date) {
			setToDate(dayjs(date).format('YYYY-MM-DD'));
		} else {
			setToDate('');
		}
	};

	const showSwitchManager = (school_id) => {
		dispatch(
			Actions.openDialog({
				children: <ChangeSchoolManagerModal onSaved={GetSchoolListing} school_id={school_id} />,
			})
		);
	};

	const handleUpdateSchoolStatus = (row) => {
		setIsRequesting(true);
		updateSchoolStatus(row.id, { status: row.status ? 0 : 1 })
			.then(() => {
				dispatch(
					Actions.showMessage({
						message: row.status ? 'School Disabled Successfuly' : 'School Enabled Successfuly',
						autoHideDuration: 1500,
						variant: 'success',
					})
				);
				setRefresh(!refresh);
				setOpen(false);
			})
			.catch((err) => {
				dispatch(
					Actions.showMessage({
						message: err?.response?.data?.message || 'Failed to update school status',
						autoHideDuration: 2000,
						variant: 'error',
					})
				);
			})
			.finally(() => {
				setIsRequesting(false);
			});
	};

	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<ConfirmModal
				description="This action cannot be undone."
				isRequesting={isRequesting}
				onConfirm={() => handleUpdateSchoolStatus(selectedToEdit)}
				open={open}
				setOpen={setOpen}
				title={`Are you sure you want to ${selectedToEdit?.status === 1 ? 'disable' : 'enable'} this school?`}
			/>
			<div className=" mb-[162px] mx-60">
				<div className=" my-[40px] flex items-end flex-nowrap justify-between">
					<span className="text-pd-2xl" style={{ fontSize: '20px', fontWeight: '700' }}>
						Schools
					</span>{' '}
					<div className="flex justify-between">
						<div className="flex justify-end">
							<TextField
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<IconButton
												onClick={() => {
													document.getElementById('search-input').focus();
												}}
											>
												<img alt="search-icon" height="80%" src="assets/images/search-icon.svg" width="80%" />
											</IconButton>
										</InputAdornment>
									),
								}}
								className="mr-10"
								id="search-input"
								label="Search"
								onChange={handleSearch}
								style={{ width: '20%' }}
								value={searchQuery}
							/>
							<div className="mx-10 student-date-field" style={{ width: '20%' }}>
								<CustomDatePicker
									id="date-from"
									label="From"
									maxDate={toDate || new Date()}
									setValue={handleFromDate}
									value={fromDate}
								/>
							</div>
							<div className="mr-20 ml-10 student-date-field" style={{ width: '20%' }}>
								<CustomDatePicker
									id="date-to"
									label="To"
									maxDate={new Date()}
									minDate={fromDate}
									setValue={handleToDate}
									value={toDate}
								/>
							</div>
						</div>
						<div className="flex self-end">
							<span>
								<span>
									<CustomButton id="go-to-add-school" onClick={goToAdd} variant="primary">
										+ Add
									</CustomButton>
								</span>
							</span>
						</div>
					</div>
				</div>

				<TableContainer
					className={`flex-1 w-full whitespace-no-wrap relative bg-white overflow-auto mt-44 p-16 rounded-lg`}
					component={Paper}
					id="Scrollable-table"
				>
					<Table aria-label="simple table" className={` table-1366x657`} stickyHeader>
						<TableHead>
							<TableRow>
								<TableCell className="bg-white school-table-header">ID</TableCell>
								<TableCell className="bg-white school-table-header">Name of School</TableCell>
								<TableCell className="bg-white school-table-header">School Admin</TableCell>
								<TableCell align="center" className="bg-white school-table-header">
									Students
								</TableCell>
								<TableCell className="bg-white school-table-header">Designation</TableCell>
								<TableCell className="bg-white school-table-header">Contact Number</TableCell>
								<TableCell className="bg-white school-table-header">Status</TableCell>
								<TableCell className="bg-white school-table-header action-div">Actions</TableCell>
							</TableRow>
						</TableHead>
						<TableBody className={classes.tableBody}>
							{isLoading ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress size={35} />
									</TableCell>
								</TableRow>
							) : !rows.length && !firstLoad ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										No Schools
									</TableCell>
								</TableRow>
							) : (
								rows?.map((row) => (
									<TableRow key={row.id}>
										<TableCell component="th" scope="row">
											{row.otp}
										</TableCell>
										<TableCell>{row.name}</TableCell>
										<TableCell>
											{`${row.admins[0]?.first_name} ${row.admins[0]?.last_name}`}
											<span className="inline-block ml-8">
												<GradientButton
													onClick={() => showSwitchManager(row.id)}
													size="pill"
													type="button"
													variant="secondary"
												>
													Switch
												</GradientButton>
											</span>
										</TableCell>
										<TableCell align="center">{row.total_students}</TableCell>
										<TableCell>{row.admins[0]?.designation}</TableCell>
										<TableCell>{row.phone}</TableCell>
										<TableCell>
											<div
												style={{
													fontWeight: 'bold',
													fontSize: 12,
													color: `${row?.status === 1 ? '#04C01C' : '#FF4B4B'}`,
												}}
											>
												{row?.status === 1 ? 'Active' : 'Inactive'}
											</div>
										</TableCell>
										<TableCell className="px-0 action-div">
											<div className="flex flex-col items-center gap-4 lg:flex-row">
												<GradientButton onClick={() => goToEdit(row)} size="pill" type="button" variant="blurple">
													Details
												</GradientButton>

												<CustomSwitch checked={row.status === 1} onChange={(e) => handleDisable(e, row)} />
											</div>
										</TableCell>
									</TableRow>
								))
							)}
							{fetchingMore ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress size={35} />
									</TableCell>
								</TableRow>
							) : null}
						</TableBody>
					</Table>
				</TableContainer>
				<InfiniteScroll
					dataLength={rows.length}
					hasMore={hasMore}
					next={handleLoadMore}
					scrollableTarget="Scrollable-table"
				/>
			</div>
		</FuseAnimate>
	);
};
export default Schools;
